import logoImg from "../../assets/logo.svg";

export default function Logo() {
  return (
    <div id="logo">
      <img src={logoImg} alt="takyon logo" />
    </div>
  );
}
